export const MIN_PASSWORD_LENGTH = 8;

export const isPasswordLongEnough = (password: string): boolean =>
  password.trim().length >= MIN_PASSWORD_LENGTH;
